<div class="d-block card container col col-xg-12 col-lg-12 col-md-12 col-xs-12 text-center w-100 p-0 m-0 py-5" style="z-index: 0;">
  <div class="top-content">
    <div class="container-fluid">

      <!-- Carrusel nativo (reemplaza ngx-owl-carousel-o). Mismo formato visual que el anterior. -->
      <div class="native-carousel position-relative destination-big">
        <button type="button" class="carousel-arrow carousel-arrow-left" (click)="carousel.prev()" aria-label="Anterior">
          <i class="bi bi-chevron-left"></i>
        </button>

        <div class="native-carousel-viewport">
          <div class="native-carousel-track"
               [style.width.%]="carousel.trackWidthPercent"
               [style.transform]="'translateX(' + carousel.translatePercent + '%)'"
               [style.transition]="carousel.transitionEnabled ? 'transform 0.7s ease' : 'none'">
            <div class="native-carousel-slide" *ngFor="let slide of carousel.extended" [style.width.%]="carousel.slideWidthPercent">
              <div (click)="articleRedirect(slide.realIndex + 1)" class="container-link position-relative mx-3">

                <img
                      usbLazyLoadImage
                      loading="lazy"
                      [lazyImage]="slide.data.image"
                      class="img-fluid mx-auto d-block image-brightness px-2"
                      alt="{{ slide.data.title }}">
                <div class="placeholder position-absolute"
                        [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                        role="status"
                        style=" top: 50%; left: 50%; transform: translate(-50%, -50%);">
                </div>
                <div class="carousel-caption d-none d-md-block p-0">
                  <div>
                    <h6 class="text-center destination-title">{{slide.data.title.substr(0, 6)}} <span><br>{{slide.data.title.substr(6)}}</span></h6>
                  </div>
                  <div class="gallery-btn text-center">
                    <button class="btn btn-usblick" [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"></button>
                  </div>
                  <p class="text-center destination-sub-title">{{slide.data.subtitle}}</p>
                  <hr class="separator">
                  <p class="text-center destination-footer-title">{{slide.data.description}}</p>
                  <div class="row m-0">
                    <div class="col-md-4 col-sm-12 col-12 mt-lg-0 pr-3 pl-3"></div>
                    <div class="col-md-4 col-sm-12 col-12 mt-lg-0 pr-3 pl-3">
                      <div class="row justify-content-center align-content-center">
                        <div class="col-md-6 col-sm-12 col-12 mt-lg-0 mt-4 py-2 pt-2 pr-3 pl-3">
                          <i aria-hidden="true"
                             class="bi bi-camera-fill destination-icon-action"
                             style="font-size: 25px"
                             title="Ver fotos del artículo"
                             (click)="openImageLightbox(slide.realIndex + 1, $event)"></i>
                        </div>
                        <div class="col-md-6 col-sm-12 col-12 mt-lg-0 mt-4 py-2 pt-2 pr-3 pl-3">
                          <i class="bi bi-chat-fill destination-icon-action"
                             style="font-size: 25px"
                             [tooltip]="commentTooltipText[slide.realIndex + 1]"
                             placement="top"
                             triggers=""
                             containerClass="destination-comment-tooltip"
                             #commentTooltip="bs-tooltip"
                             (click)="onCommentClick(slide.realIndex + 1, commentTooltip, $event)"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 col-sm-12 col-12 mt-lg-0 pr-3 pl-3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button type="button" class="carousel-arrow carousel-arrow-right" (click)="carousel.next()" aria-label="Siguiente">
          <i class="bi bi-chevron-right" style="font-size: 50px"></i>
        </button>
      </div>

      <!-- Carrusel anterior (ngx-owl-carousel-o). Se deja comentado hasta confirmar que el nativo quedó bien. -->
      <!--
      <owl-carousel-o [options]="customOptions" class="destination-big">
        <ng-container *ngFor="let destination of destinations; let i = index">
          <ng-template carouselSlide>
            <div (click)="articleRedirect(i + 1)" class="container-link position-relative mx-3">

              <img
                    usbLazyLoadImage
                    loading="lazy"
                    [lazyImage]="destination.image"
                    class="img-fluid mx-auto d-block image-brightness px-2"
                    alt="{{ destination.title }}">
              <div class="placeholder position-absolute"
                      [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                      role="status"
                      style=" top: 50%; left: 50%; transform: translate(-50%, -50%);">
              </div>
            <div class="carousel-caption d-none d-md-block p-0">
              <div>
                <h6 class="text-center destination-title">{{destination.title.substr(0, 6)}} <span><br>{{destination.title.substr(6)}}</span></h6>
              </div>
              <div class="gallery-btn text-center">
                <button class="btn btn-usblick" [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"></button>
              </div>
              <p class="text-center destination-sub-title">{{destination.subtitle}}</p>
              <hr class="separator">
              <p class="text-center destination-footer-title">{{destination.description}}</p>
              <div class="row m-0">
                <div class="col-md-4 col-sm-12 col-12 mt-lg-0 pr-3 pl-3"></div>
                <div class="col-md-4 col-sm-12 col-12 mt-lg-0 pr-3 pl-3">
                  <div class="row justify-content-center align-content-center">
                    <div class="col-md-4 col-sm-12 col-12 mt-lg-0 mt-4 py-2 pt-2 pr-3 pl-3" >
                      <i aria-hidden="true" class="bi bi-camera-fill" style="font-size: 25px"></i>
                    </div>
                    <div class="col-md-4 col-sm-12 col-12 mt-lg-0 mt-4 py-2 pt-2 pr-3 pl-3">
                      <i class="bi bi-camera-reels-fill" style="font-size: 25px;"></i>
                    </div>
                    <div class="col-md-4 col-sm-12 col-12 mt-lg-0 mt-4 py-2 pt-2 pr-3 pl-3">
                      <i class="bi bi-chat-fill" style="font-size: 25px"></i>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-sm-12 col-12 mt-lg-0 pr-3 pl-3"></div>
              </div>
            </div>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
      -->
    </div>
  </div>
</div>

<!-- Lightbox para la cámara: fotos del artículo al que apunta la tarjeta (misma consulta que
     usa usb-article), mismo patrón que la galería del artículo. -->
<div class="destination-lightbox"
     *ngIf="imageLightboxOpen"
     role="dialog"
     aria-modal="true"
     (click)="closeImageLightbox()">
  <button type="button" class="destination-lightbox_close" (click)="closeImageLightbox($event)" aria-label="Cerrar">
    <i class="bi bi-x-lg"></i>
  </button>
  <button type="button" *ngIf="imageLightboxImages.length > 1" class="destination-lightbox_nav destination-lightbox_nav--prev" (click)="imageLightboxPrev($event)" aria-label="Anterior">
    <i class="bi bi-chevron-left"></i>
  </button>
  <button type="button" *ngIf="imageLightboxImages.length > 1" class="destination-lightbox_nav destination-lightbox_nav--next" (click)="imageLightboxNext($event)" aria-label="Siguiente">
    <i class="bi bi-chevron-right"></i>
  </button>
  <img *ngIf="imageLightboxImages.length > 0"
       [src]="imageLightboxImages[imageLightboxIndex]"
       class="destination-lightbox_img"
       alt=""
       (click)="$event.stopPropagation()"
       (error)="onLightboxImageError($event)">
  <p *ngIf="imageLightboxImages.length === 0" class="destination-lightbox_empty">
    Todavía no hay fotos cargadas para este destino.
  </p>
</div>
